import { Client } from 'src/admin/users/types';
import { CreateFamilyPayload, FamilyMemberWithRelation } from '../hooks/useCreateFamily';
import { Relation } from '../hooks/useFamily';

export type V2MemberRelationship = {
  relation: Relation | null;
  toMemberId: string | null;
};

export type InProgressFamilyV2 = {
  selectedMembers: Client[];
  relationships: Record<string, V2MemberRelationship>;
  name: string;
};

export function generateFamilyName(members: Client[]): string {
  if (members.length === 0) return '';
  if (members.length === 1) return `${members[0].firstName} ${members[0].lastName}`;

  const allSameLastName = members.every(m => m.lastName === members[0].lastName);

  if (allSameLastName) {
    const firstNames = members.map(m => m.firstName);
    const allButLast = firstNames.slice(0, -1).join(', ');
    const lastFirst = firstNames[firstNames.length - 1];
    return `${allButLast} & ${lastFirst} ${members[0].lastName}`;
  }

  return `${members[0].firstName} ${members[0].lastName} & ${members[1].firstName} ${members[1].lastName}`;
}

export function getAdvisorUserId(
  members: Client[],
  currentUser: { id?: string } | undefined,
  isSystemAdmin: boolean,
  isServiceAdmin: boolean,
): string {
  if (isSystemAdmin || isServiceAdmin) {
    return members.find(m => m.advisorUserId)?.advisorUserId ?? currentUser?.id ?? '';
  }
  return currentUser?.id ?? '';
}

export function isMemberSelected(client: Client, selectedMembers: Client[]): boolean {
  return selectedMembers.some(m => m.id === client.id);
}

export function payloadFromInProgressFamilyV2(
  family: InProgressFamilyV2,
  advisorUserId: string,
): CreateFamilyPayload {
  const [primary, ...secondaries] = family.selectedMembers;

  return {
    name: family.name,
    advisorUserId,
    mainFamilyMember: { clientId: primary.id },
    secondaryFamilyMembers: secondaries.map(
      member =>
        ({
          clientId: member.id,
          relationshipToMainFamilyMember: family.relationships[member.id]?.relation ?? 'Other',
        }) as FamilyMemberWithRelation,
    ),
  };
}
